<template>
  <div
    class="d2-layout-header-aside-group"
    :style="styleLayoutMainGroup"
    :class="{grayMode: isGrayMode}">
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶部Banner区域 -->
        <div class="sec_header">
            <div class="sec_mbox clearfix" style="position:relative;">
                <el-row>
                    <el-col :span="16">
                        <!--<img width="65" height="65" style="position:absolute;left:10px;top:25px;" src="/image/appstore/logo-one.png"/>-->
                        <a class="sec_LogoL fl" href="javascript:;" style="margin-left:20px;"></a>
                    </el-col>
                    <!--<el-col :span="8">
                        <a style="" class="sec_LogoR fr" href="javascript:;"></a>
                    </el-col>-->
                    <el-col :span="8" class="d2-theme-header">
                        <div class="d2-header-right" style="height: 80px;">
                            <!--<d2-header-help/>-->
                            <d2-header-fullscreen/>
                            <d2-header-theme/>
                            <d2-header-user/>
                            <!--<d2-header-user-appstore/>-->
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
      <!-- 顶栏 -->
      <!--<div class="d2-theme-header" flex-box="0">
        <div class="logo-group" :style="{width: isMenuAsideCollapse ? asideWidthCollapse : asideWidth,height:'50px'}">
          <img v-if="isMenuAsideCollapse" :src="`${$baseUrl}image/theme/${d2adminThemeActiveSetting.name}/logo/icon-only.png`">
          <img v-else :src="`${$baseUrl}image/theme/${d2adminThemeActiveSetting.name}/logo/all.png`">
        </div>
        <div class="toggle-aside-btn" @click="handleToggleAside">
          <d2-icon name="bars"/>
        </div>
        <d2-menu-header/>
        &lt;!&ndash; 顶栏右侧 &ndash;&gt;
        <div class="d2-header-right">
          &lt;!&ndash;<d2-header-help/>&ndash;&gt;
          <d2-header-fullscreen/>
          <d2-header-theme/>
          <d2-header-user/>
          &lt;!&ndash;<d2-header-user-appstore/>&ndash;&gt;
        </div>
      </div>-->
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 侧边栏 -->
        <div
          flex-box="0"
          ref="aside"
          class="d2-theme-container-aside"
          :style="{width: isMenuAsideCollapse ? asideWidthCollapse : asideWidth}">
          <d2-menu-side/>
        </div>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex="dir:top">
          <div class="d2-theme-container-main-header" flex-box="0">
            <d2-tabs :isShowTabsToggleAside="true"/>
            <d2-breadcrumb/>
          </div>
          <div class="d2-theme-container-main-body" flex-box="1">
            <!--<transition name="fade-transverse">
              &lt;!&ndash;<keep-alive :include="d2adminKeepAliveInclude">
                <router-view/>
              </keep-alive>&ndash;&gt;
              <router-view/>
            </transition>-->
              <div class="slideoutContainerParent">
                  <Slideout class="slideoutContainer" ref="slideout" easing="cubic-bezier" :touch="false" menu="#menu" panel="#panel" :toggleSelectors="['.toggle-button']"
                            @on-open="open"
                            @on-beforeopen="beforeopen"
                            @on-beforeclose="beforeclose">
                      <nav id="menu">
                          <d2-menu-slideout @closeSlideout="slideoutClose" />
                      </nav>
                      <main id="panel" :class="['panel','slideout-panel','slideout-panel-left',{'panel-open':panelOpen,}]" @click="slideoutCloseByOvermask">
                          <div id="mobile-bar">
                              <a class="toggle-button menu-button"></a>
                              <a class="logo" href="/"></a>
                              <div class="loginBtnGroup">
                                  <d2-header-user-appstore/>
                              </div>
                          </div>
                          <div id="slideout-view">
                              <!--<transition name="fade-transverse">
                                  <keep-alive :include="d2adminKeepAliveInclude">
                                      <router-view/>
                                  </keep-alive>
                              </transition>-->
                              <transition :name="device==='mobile'?'':'fade-transverse'">
                                  <router-view/>
                              </transition>
                          </div>
                      </main>
                  </Slideout>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Slideout from 'vue-slideout'
import menuSide from './components/menu-side'
import menuHeader from './components/menu-header'
import tabs from './components/tabs'
import breadcrumb from './components/breadcrumb'
import headerFullscreen from './components/header-fullscreen'
import headerTheme from './components/header-theme'
import headerUser from './components/header-user'
import headerUserAppstore from './components/header-user-appstore'
import headerHelp from './components/header-help'
import menuSlideout from '@/layout/header-aside/components/menu-slideout'
import ResizeMixin from '@/layout/mixin/ResizeHandler'

export default {
  name: 'd2-layout-header-aside',
  components: {
      Slideout,
      'd2-menu-slideout': menuSlideout,
    'd2-menu-side': menuSide,
    'd2-menu-header': menuHeader,
    'd2-tabs': tabs,
    'd2-breadcrumb': breadcrumb,
    'd2-header-fullscreen': headerFullscreen,
    'd2-header-theme': headerTheme,
    'd2-header-user': headerUser,
    'd2-header-user-appstore': headerUserAppstore,
    'd2-header-help': headerHelp
  },
    mixins: [ResizeMixin],
  data () {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '0px',
      //侧边栏是否打开标识，用于控制遮罩层
      panelOpen: false,
      //遮罩层关闭侧边栏事件的开关
      panelOpenCloseEvent: false
    }
  },
  computed: {
    ...mapState({
      isGrayMode: state => state.d2admin.isGrayMode,
      pageOpenedList: state => state.d2admin.pageOpenedList,
      isMenuAsideCollapse: state => state.d2admin.isMenuAsideCollapse,
      device: state => state.d2admin.device
    }),
    ...mapGetters([
      'd2adminThemeActiveSetting',
      'd2adminKeepAliveInclude'
    ]),
    menuHeader() {
      return this.$store.state.menuHeader
    },
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup () {
      return {
        ...this.d2adminThemeActiveSetting.backgroundImage ? {
          backgroundImage: `url('${this.$baseUrl}${this.d2adminThemeActiveSetting.backgroundImage}')`
        } : {}
      }
    }
  },
  methods: {
    ...mapMutations([
      'd2adminMenuAsideCollapseToggle'
    ]),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside () {
      this.d2adminMenuAsideCollapseToggle()
    },
      // 以下是手机版布局slideout插件使用的函数
      beforeopen: function (){
          //console.log('beforeopen');
          //打开遮罩效果
          this.panelOpen = true
      },
      open: function () {
          //console.log('slideoutOpen')
          //开启遮罩层点击关闭侧边事件
          this.panelOpenCloseEvent = true
      },
      //关闭侧边栏
      slideoutClose: function () {
          //this.$children[0].slideout.close()
          this.$refs.slideout.slideout.close()
          this.panelOpen = false
      },
      beforeclose: function () {
          //console.log('beforeclose')
          this.panelOpen = false
          this.panelOpenCloseEvent = false
      },
      //内容区域，即遮罩区域的点击事件
      slideoutCloseByOvermask: function () {
          if(this.panelOpenCloseEvent){
              this.slideoutClose()
          }
      }
  }
}
</script>

<style lang="scss">
// 注册主题（桌面和手机布局通用）
@import '~@/assets/style/theme/register.scss';
// 注册主题（只用于手机布局）
@import '~@/assets/style/theme/mobile.scss';

</style>

<style lang="scss" scoped>
    //以下样式针对banner区域

    //隐藏显示原有Logo区域
    .d2-theme-header .logo-group img{
        display: none;
    }
    //左侧菜单栏上浮，遮盖原Logo区域
    .d2-theme-container .d2-theme-container-aside{
        top:0px;
    }

    .sec_mbox {
        //width: 1250px;
        margin: 0 auto;
    }

    .sec_wrap {
        min-height: 100%;
    }

    .sec_main {
        overflow: hidden;
        padding-bottom: 333px;
    }

    .sec_copyright {
        margin-top: -333px;
    }

    .sec_center {
        text-align: center;
    }

    /* 清除浮动 */

    .fl {
        float: left;
    }

    .fr {
        float: right;
    }

    .clearfix:after {
        content: '';
        display: block;
        clear: both;
    }

    .clearfix {
        zoom: 1;
    }


    // 顶部Banner区域
    .sec_header {
        /*background: -webkit-linear-gradient(#c4e0ff, #e9f5ff);*/
        /*!* Safari 5.1 - 6.0 *!*/
        /*background: -o-linear-gradient(#c4e0ff, #e9f5ff);*/
        /*!* Opera 11.1 - 12.0 *!*/
        /*background: -moz-linear-gradient(#c4e0ff, #e9f5ff);*/
        /*!* Firefox 3.6 - 15 *!*/
        background: linear-gradient(rgba(196, 224, 255, 0.85), rgba(233, 245, 255, 0.85));
        /* 标准的语法 */
    }

    .sec_header .sec_LogoL {
        width: 546px;
        height: 80px;
        background: url(/image/appstore/logoL.png) no-repeat center;
    }

    .sec_header .sec_LogoR {
        width: 453px;
        height: 116px;
        margin-right: 48px;
        background: url(/image/appstore/logoR.png) no-repeat center;
    }

    .clearfix a {
        color: #0162f4;
    }

    .clearfix a:hover {
        text-decoration: underline;;
    }

    @media screen and (max-width: 1170px){
        .sec_header .sec_LogoR {
            margin-right: 10px;
        }
    }
    @media screen and (max-width: 1100px){
        .sec_header .sec_LogoR {
            background: none;
        }
    }
</style>

<!-- 以下样式是手机slideout和PC布局模式的对应样式代码 -->
<!--手机版本对应页面-->
<style scoped>
    @media screen and (max-width: 1030px){
        #mobile-bar {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 40px;
            background-color: #fff;
            backface-visibility: hidden;
            z-index: 2;
            /*display: none;*/
            box-shadow: 0 0 2px rgba(0,0,0,0.25);
        }
        #mobile-bar .menu-button {
            position: absolute;
            width: 40px;
            height: 40px;
            top: 0;
            left: 5px;
            background: url("/image/slideout/menu.png") center center no-repeat;
            background-size: 24px;
        }
        #mobile-bar .logo {
            position: absolute;
            width: 30px;
            height: 30px;
            background: url("/image/appstore/logo-one.png") center center no-repeat;
            top: 5px;
            left: 50%;
            margin-left: -15px;
            background-size: 30px;
        }
        #mobile-bar .loginBtnGroup {
            float: right;
            line-height: 40px;
            height: 40px;
            width: 40px;
            text-align: center;
        }
    }
</style>
<style scoped>
    /* 桌面版本布局时 */
    @media screen and (min-width: 1030px){
        .slideout-menu {
            display: none;
        }
        #mobile-bar {
            display: none;
        }
    }
    /* 手机布局时生效 */
    @media screen and (max-width: 1030px){
        .slideoutContainer{
            overflow: hidden;
            position: relative;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
        #slideout-view{
            position: relative;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            overflow: auto;
            margin-top: 40px;
            padding: 0;
            -webkit-overflow-scrolling: touch;
            overflow: auto;
        }

        body {
            width: 100%;
            height: 100%;
        }

        .slideout-menu {
            position: fixed;
            top: 0;
            bottom: 0;
            width: 256px;
            min-height: 100vh;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            z-index: 0;
            display: none;
            background: #545c64;
        }

        .slideout-menu .el-menu{
            border-right: none;
        }

        .slideout-menu-left {
            left: 0;
        }

        .slideout-menu-right {
            right: 0;
        }

        .slideout-panel {
            position: relative;
            /*z-index: 1;*/
            /*will-change: transform;*/
            background-color: #FFF; /* A background-color is required */
            min-height: 100vh;
            overflow: auto;
        }

        .slideout-open,
        .slideout-open body,
        .slideout-open .slideout-panel {
            overflow: hidden;
        }

        .slideout-open .slideout-menu {
            display: block;
        }

        .fixed-header {
            position: fixed;
            width: 100%;
            height: 50px;
            backface-visibility: hidden;
            z-index: 2;
            /*background-color: red;*/
        }

        /* add an overlay to close the menu on click */
        .panel:before {
            content: '';
            display: block;
            background-color: rgba(0,0,0,0);
            transition: background-color 0.5s ease-in-out;
        }

        .panel-open:before {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 100%;
            background-color: rgba(0,0,0,.5);
            z-index: 99;
        }

        /* begin-手机版隐藏或改变PC版部分元素 */
        .d2-theme-container-main-header{
            display: none;
        }
        .sec_header{
            display: none;
        }
        .d2-theme-header{
            display: none;
        }
        .slideoutContainerParent{
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
        .d2-layout-header-aside-group{
            position: static;
        }
        .d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-main{
            position: static;
        }
        .d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-main .d2-theme-container-main-body{
            position: static;
        }
        /* end-手机版隐藏或改变PC版部分元素 */
    }

</style>
